export const ACT_AS_HEADER = 'x-mhx-act-as-user';

export const ACT_AS_SESSION_KEY = 'mhx.beta.actAsUserId';
